<template>
    <button @click="report" type="button" class="btn btn-sm btn-blue btn-main btn-popup" :disabled="isDisabled">
        {{$t("btnReport")}}
    </button>
</template>

<script>
    export default {
        props: {
          isDisabled: {
              type: Boolean,
              default: false
          },
          circle: {
              type: Object
          },
          isCircleMode: {
              type: Boolean,
              default: false
          }
        },
        data() {
          return {
              link: ''
          }
        },
        methods: {
            report() {
                if(this.isCircleMode) {
                    this.pdfReportCircle();
                } else {
                    this.pdfReportLocation();
                }
            },
            async pdfReportLocation() {
                try {
                    let response = await this.$store.dispatch('pdfReportLocation');
                    this.forceFileDownload(response.data.data.url)
                } catch(e) {
                    console.log(e, 'e hello world')
                }
            },
            async pdfReportCircle() {
               try {
                   let response = await this.$store.dispatch('pdfReportCircle', this.circle);
                   let url = response.data.data.url;
                   this.forceFileDownload(url, true);
               } catch(e) {
                   console.log(e, 'e hello world')
               }
            },
            forceFileDownload(path, target){
                let filename = "report.pdf"
                let link = document.createElement('a');
                if(target) link.setAttribute('target', '_blank');
                link.setAttribute('href', path);
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
</script>
